import { times } from "lodash";
import * as React from "react";
import { useLocation } from "react-router";
import { THEME } from "../../theme/ThemeStore";

type LoadingBarProps = { elements: string[] };

export const LoadingBar = ({ elements }: LoadingBarProps) => {
    const { pathname } = useLocation();
    const [activeIndex, setActiveIndex] = React.useState(0);

    React.useEffect(() => {
        const index = elements.findIndex((element) => pathname === element);
        if (index >= 0) {
            setActiveIndex(index);
        }
    }, [elements, pathname]);

    return (
        <div
            style={{
                height: 5,
                display: "flex"
            }}
        >
            {times(elements.length, (index) => (
                <SingleStep active={activeIndex >= index} maxSteps={elements.length} key={index} />
            ))}
        </div>
    );
};

type SingleStepProps = { active?: boolean; maxSteps: number };

const SingleStep = ({ active, maxSteps }: SingleStepProps) => (
    <div
        style={{
            width: `${100 / maxSteps}%`,
            height: 5,
            backgroundColor: active ? THEME.customColors.primary : THEME.customColors.white
        }}
    />
);
